module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ed-title-nav', {
    attrs: {
      "title": "Settings"
    }
  }), _c('div', {
    staticClass: "container-fluid"
  }, [_c('ed-section', {
    staticClass: "active"
  }, _vm._l((_vm.settings), function(setting, index) {
    return _c('ed-card', {
      key: setting.name,
      attrs: {
        "title": setting.name,
        "subtitle": setting.description,
        "footer-button": setting.configurable,
        "icon": setting.icon
      }
    }, [_c('ed-switch', {
      attrs: {
        "slot": "top"
      },
      slot: "top",
      model: {
        value: (setting.status),
        callback: function($$v) {
          _vm.$set(setting, "status", $$v)
        },
        expression: "setting.status"
      }
    }), _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [(setting.configurable != "false") ? _c('ed-button', {
      attrs: {
        "disabled": !setting.status,
        "button-class": "btn btn-actionbar"
      },
      on: {
        "click": _vm.edit
      }
    }, [_vm._v(_vm._s(setting.configurable))]) : _vm._e()], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d7c42bb","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Admin/settings.vue
// module id = ozwW
// module chunks = 13 14